import OrganisationLayout from "../layout/OrganisationLayout";
import Container from "react-bootstrap/Container";

export default function OrganisationGroupsSchoolDetails() {
  return (
    <OrganisationLayout>
      <Container fluid>
        <div className="heading-top mt-5 mb-2">
          <h2>School Details</h2>
        </div>
        <section className="organisation-groups-card organisation-groups-table-shell-space">
          <h3>Organisation Group</h3>
          <p>
            This separate school details screen is ready for the new
            organisation-group messaging and help content from the document.
          </p>
        </section>
      </Container>
    </OrganisationLayout>
  );
}
